/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-08 15:44:58
 * @LastEditors: caiqin.xie
 * @message: 博客左侧产品banner
 */
import React from "react";
import BuyButton from "@/components/BuyButton";
import { useDevice } from "@/hooks";
import styles from "../../index.module.scss";
import LazyMedia from "@/components/LazyMedia";

interface IProps {
  hostBanner: Record<string, any>; // 主机banner
  ctry: string;
  words: Record<string, string>;
}

const HostBanner = (props:IProps) => {
  const {ctry, hostBanner, words} = props
  const device = useDevice()
  const newDevice = (device === '' ? 'pc' : device === 'paid' ? 'pad' : device)
  return (
    <>
     {hostBanner && (
        <div className={`${styles['blog-left-banner']} ${styles['blog-host-banner']}`}>
          <div className={styles['host-pic']}>
            {
              hostBanner[newDevice].extension === '.mp4'
              ? <LazyMedia type="video" LazyClassName="full-wh" loop autoPlay preload="auto" playsInline muted src={hostBanner[newDevice]?.url}></LazyMedia>
              : <LazyMedia type="image" LazyClassName="full-wh" src={hostBanner[newDevice]?.url} alt={hostBanner[newDevice]?.alt} />
            }
          </div>
          <div className={styles['host-content']}>
            {hostBanner?.isShowTitle === 1 && (
              <p className={styles['host-title']}>{hostBanner?.name}</p>
            )}
            <p className={styles['host-desc']} title={hostBanner?.briefIntroduction}>{hostBanner?.briefIntroduction}</p>
            <div className={styles['btn-group']}>
              <BuyButton buyPaths={hostBanner?.buyPaths} words={words} className={styles['custom-btn']} />
              {hostBanner?.url && (
                <button className={styles["purple-line"]}>
                  <a href={hostBanner?.url}>{words?.common_learn_more}</a>
                </button>
              )}
              {/* Buy Now */}
              {/* Load More */}
            </div>
          </div>
        </div>
     )}
    </>

  )
}
export default HostBanner
